/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { camelCase, camelCaseTransformMerge } from 'camel-case';
import { IMockProps, Method, MockApiType } from '../types';

export const setEntityName = (URL: string): string => {
  const entityName = camelCase(URL, {
    transform: camelCaseTransformMerge,
  });

  return `${entityName}Response`;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types*/
export const getMocksProps = (mocksServiceFlow: any[]) => {
  const mocksService: any[] = mocksServiceFlow.map((msf) => {
    return {
      label: msf.label,
      value: msf.value,
    };
  });
  /* eslint-enable @typescript-eslint/no-explicit-any */
  /* eslint-enable @typescript-eslint/explicit-module-boundary-types*/

  const mocksCases: MockApiType[] = [];
  const m = mocksCases;
  mocksServiceFlow.forEach((element) => {
    mocksCases.push.apply(m, element.apiMocks);
  });

  const mocksProps: IMockProps[] = mocksCases.map((el) => ({
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: el.method as Method,
      path: el.path,
      body: el.body,
    },
    configResponse: {
      status: el.status,
      data: el.data,
    },
  }));

  return {
    mocksService,
    mocksProps,
  };
};
